import ClientHandbookArticleComponent from './client-handbook-article/client-handbook-article'
import ClientHandbookIndexComponent from './client-handbook-index/client-handbook-index'
import GlobalHeaderComponent from './global-header/global-header'
import HashAnchorComponent from './hash-anchor/hash-anchor'
import HeroComponent from './hero/hero'
import LottieComponent from './lottie/lottie'
import MailchimpFormComponent from './mailchimp-form/mailchimp-form'
import OverflowAutoComponent from './overflow-auto/overflow-auto'
import ScrollRevealComponent from './scroll-reveal/scroll-reveal'
import SlideshowComponent from './slideshow/slideshow'
import PanolensComponent from './panolens/panolens'
import TabsComponent from './tabs/tabs'
import UnderlineTextComponent from './underline-text/underline-text'
import VideoSrcsetComponent from './video-srcset/video-srcset'
import VizBannerComponent from './vizbanner/vizbanner'
import StickyNavComponent from './sticky-nav/sticky-nav'
import VideoScrollComponent from './video-scroll/video-scroll'

export const Components = {
    GlobalHeaderComponent,
    HeroComponent,
    HashAnchorComponent,
    LottieComponent,
    ClientHandbookIndexComponent,
    ClientHandbookArticleComponent,
    MailchimpFormComponent,
    TabsComponent,
    SlideshowComponent,
    PanolensComponent,
    UnderlineTextComponent,
    ScrollRevealComponent,
    VideoSrcsetComponent,
    OverflowAutoComponent,
    VizBannerComponent,
    StickyNavComponent,
    VideoScrollComponent
}
